export const channels = (
    state = {
      channels: []
    }) => { return state; };
  